import React from 'react';
import { Grid, Typography, Card, CardContent, TextField, Button, Stack, Link, Container } from '@mui/material';

import Page from './Page';
import Header from './Header';

const Support = () => {
  const contactOptions = [
    { label: 'Email', value: 'support@diycasinoparty.com' },
    { label: 'Phone', value: '(404) 555-0142' },
    { label: 'Live Chat', value: 'Weekdays 9am – 7pm ET' }
  ];

  return (
    <Page sx={{ background: '#fdf6ea' }}>
      <Container maxWidth="lg">
        <Header text="Support & Contact" subHeader="We are here to help before, during and after your event" />
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', boxShadow: '0 20px 45px rgba(0,0,0,0.08)' }}>
              <CardContent>
                <Typography variant="h4" gutterBottom>Contact Details</Typography>
                <Stack spacing={2}>
                  {contactOptions.map(option => (
                    <div key={option.label}>
                      <Typography variant="subtitle2" sx={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}>{option.label}</Typography>
                      <Typography variant="body1">{option.value}</Typography>
                    </div>
                  ))}
                  <Typography variant="body2">
                    Need to adjust a booking? Email us your order number or reply directly to the shipping confirmation so we can prioritize your request.
                  </Typography>
                  <Typography variant="body2">
                    Download care instructions and return checklists from our <Link href="/support#resources">resource library</Link>.
                  </Typography>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={6}>
            <Card sx={{ height: '100%', boxShadow: '0 20px 45px rgba(0,0,0,0.08)' }}>
              <CardContent>
                <Typography variant="h4" gutterBottom>Send a Message</Typography>
                <Stack spacing={2} component="form">
                  <TextField label="Full Name" fullWidth required />
                  <TextField label="Email" type="email" fullWidth required />
                  <TextField label="Order Number (optional)" fullWidth />
                  <TextField label="Message" multiline rows={4} fullWidth required />
                  <Button variant="contained" color="primary">Submit Request</Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        <Stack spacing={2} sx={{ mt: 4 }} id="resources">
          <Typography variant="h4">Resource Library</Typography>
          <Typography variant="body1">
            Access printable setup guides, game rules, and return reminders tailored to each casino cloth. We update the library frequently with new themes and fundraising tips. Bookmark the page after checkout so your team has everything in one place.
          </Typography>
        </Stack>
      </Container>
    </Page>
  );
};

export default Support;
